import React from "react";
//#region types
import { UrgencyIndicatorProps } from "models/propTypes/todoPropTypes";
//#endregion
//#region components
import { StatusIndicatorSmall } from "components/common";
import { useTodoService } from "serviceHooks";
//#endregion

const UrgencyIndicator: React.FC<UrgencyIndicatorProps> = (props) => {
  const todoService = useTodoService();
  const { urgency } = props;

  return <StatusIndicatorSmall displayType={todoService.getUIDisplayTypeByUrgency(urgency)} />;
};

export default UrgencyIndicator;
